import antdFr from "antd/lib/locale-provider/fr_FR";
import appLocaleData from "react-intl/locale-data/fr";
import enMessages from "../locales/en_US.json";
import frMessages from "../locales/fr_FR.json";

const FrLang = {
  messages: {
    ...enMessages,
    ...frMessages
  },
  antd: antdFr,
  locale: 'fr',
  data: appLocaleData
};
export default FrLang;
